export default __webpack_public_path__ + "static/kids-6343856f1f9f4286c76ae68ad19752d5.jpg";